import Avatar from 'primevue/avatar';
import Button from 'primevue/button';
import type { FunctionalComponent } from 'vue';
import { Typography } from '@apparatix/library/core';
import type { ContactLabelType } from '@apparatix/types/Leads';

type Props = {
  id: number | string;
  name: string;
  closable?: boolean;
  copyable?: boolean;
  types?: boolean;
  variant?: 'search' | 'card'
  company?: string;
  tags?: string[];
  owner?: string;
}

type Emits = {
  onClose(id: number | string): void;
  onCopy(id: number | string): void;
  onTypeChange(types: ContactLabelType): void;
}

export const ContactCard: FunctionalComponent<Props, Emits> = ({
  id,
  name,
  closable,
  copyable,
  variant = 'card',
  company,
  owner,
}, { emit, slots }) => {
  const onCopyClick = (e: MouseEvent) => {
    e.stopImmediatePropagation();
    emit('onCopy', id);
  };

  return (
    <div
      class={[
        'flex flex-col gap-3 w-full',
        variant === 'card' ? 'p-3 rounded-lg border border-[var(--p-content-border-color)] bg-white' : 'bg-transparent',
      ]}
      style={{ 'box-shadow': variant === 'card' ? '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)' : 'none' }}
    >
      <div class="flex justify-between">
        <div class="flex flex-col gap-2">
          <Typography variant="section-subheading">{ name }</Typography>
          {Boolean(company) && <Typography variant="small-subtitle" muted>{ company }</Typography>}
        </div>
        {closable && !copyable &&
        <Button icon="pi pi-times" variant="text" aria-label="Remove contact" severity="secondary" rounded onClick={() => emit('onClose', id)} />
        }
        {copyable && !closable &&
        <Button icon="pi pi-copy" variant="outlined" aria-label="Copy contact" rounded onClick={onCopyClick} />
        }
      </div>
      {Boolean(slots?.default) && slots.default()}
      {Boolean(owner) && (
        <div class="flex items-center gap-2">
          <Avatar icon="pi pi-user" style="background: var(--p-surface-100)" shape="circle" />
          <Typography variant="form-label">{ owner }</Typography>
        </div>
      )}
    </div>
  );
};
